import { v4 as uuid } from 'uuid';

const oracleSysGuidUuid = () => uuid().replace(/-/g, '').toUpperCase();

export default oracleSysGuidUuid;
